/**
 * US English (USD) mock entity data for the marketing-site mockups.
 * Row shapes mirror the app's API rows (see shared-site-web/screens/*.js),
 * so the real column definitions and table components can render them.
 */

/** @type {Array<import('../../mock-data.js').MockAccount>} */
export const MOCK_ACCOUNTS_EN_US = [
	{ id: 'acc-checking', name: 'Chase Checking', accountType: 'Bank Account', currency: 'USD', currencySymbol: '$', currencyDecimalPlaces: 2, balance: 4800, principal: null, updatedAt: '2026-08-08' },
	{ id: 'acc-savings', name: 'High-Yield Savings', accountType: 'Bank Account', currency: 'USD', currencySymbol: '$', currencyDecimalPlaces: 2, balance: 15600, principal: null, updatedAt: '2026-08-08' },
	{ id: 'acc-broker', name: 'Brokerage', accountType: 'Investment Account', currency: 'USD', currencySymbol: '$', currencyDecimalPlaces: 2, balance: 42000, principal: 44500.4, updatedAt: '2026-08-08' },
	{ id: 'acc-pension', name: '401(k)', accountType: 'Pension', currency: 'USD', currencySymbol: '$', currencyDecimalPlaces: 2, balance: 96000, principal: null, updatedAt: '2026-08-08' },
	{ id: 'acc-property', name: 'Home', accountType: 'Real Estate', currency: 'USD', currencySymbol: '$', currencyDecimalPlaces: 2, balance: 480000, principal: 380000, updatedAt: '2026-08-08' },
	{ id: 'acc-flight', name: 'Flight Mileage', accountType: 'Points/Miles', currency: 'MILES', currencySymbol: '\u2708', currencyDecimalPlaces: 0, balance: 84620, principal: null, updatedAt: '2026-08-08' },
	{ id: 'acc-credit', name: 'Travel Rewards Card', accountType: 'Credit Card', currency: 'USD', currencySymbol: '$', currencyDecimalPlaces: 2, balance: 1560, principal: null, updatedAt: '2026-08-08' },
	{ id: 'acc-joke', name: 'Lago Vista IRA', accountType: 'Investment Account', currency: 'USD', currencySymbol: '$', currencyDecimalPlaces: 2, balance: 22500, principal: 12490.28, updatedAt: '2026-08-08' },
];

/**
 * Custom currencies (USD base) for the currencies use case. MILES and HP
 * carry a manual rate so the currency table shows the manual marker "(M)".
 * @type {Array<import('../../mock-data.js').MockCurrency>}
 */
export const MOCK_CURRENCIES_EN_US = [
	{ code: 'USD', isCustom: 0, name: 'US Dollar', symbol: '$', decimalPlaces: 2, isBase: 1, rate: 1, manualRate: null },
	{ code: 'GBP', isCustom: 0, name: 'British Pound', symbol: '\u00A3', decimalPlaces: 2, isBase: 0, rate: 1.27, manualRate: null },
	{ code: 'MILES', isCustom: 1, name: 'Flight Mileage', symbol: '\u2708', decimalPlaces: 0, isBase: 0, rate: 0.012, manualRate: 0.012 },
	{ code: 'HP', isCustom: 1, name: 'Hotel Points', symbol: 'P', decimalPlaces: 0, isBase: 0, rate: 0.01, manualRate: 0.01 },
	{ code: 'SM', isCustom: 1, name: 'Status Miles', symbol: 'SM', decimalPlaces: 0, isBase: 0, rate: 0, manualRate: 0 },
];

/**
 * Everyday currencies (USD base) with auto-fetched rates for the
 * multi-currency use case.
 * @type {Array<import('../../mock-data.js').MockCurrency>}
 */
export const MOCK_RATES_EN_US = [
	{ code: 'USD', isCustom: 0, name: 'US Dollar', symbol: '$', decimalPlaces: 2, isBase: 1, rate: 1, manualRate: null },
	{ code: 'GBP', isCustom: 0, name: 'British Pound', symbol: '\u00A3', decimalPlaces: 2, isBase: 0, rate: 1.27, manualRate: null },
	{ code: 'EUR', isCustom: 0, name: 'Euro', symbol: '\u20AC', decimalPlaces: 2, isBase: 0, rate: 1.09, manualRate: null },
	{ code: 'JPY', isCustom: 0, name: 'Japanese Yen', symbol: '\u00A5', decimalPlaces: 0, isBase: 0, rate: 0.0068, manualRate: null },
];
